import { render, staticRenderFns } from "./card-1.vue?vue&type=template&id=0d73f0d8&scoped=true"
import script from "./card-1.vue?vue&type=script&lang=js"
export * from "./card-1.vue?vue&type=script&lang=js"
import style0 from "./card-1.vue?vue&type=style&index=0&id=0d73f0d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d73f0d8",
  null
  
)

export default component.exports